import { InboxOutlined } from '@ant-design/icons'

type Props = {
  title?: string
  description?: string
  action?: React.ReactNode
}

export function EmptyState({ title = 'No data', description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <InboxOutlined className="text-4xl text-gray-300 mb-3" />
      <p className="text-sm font-medium text-gray-500">{title}</p>
      {description && <p className="text-xs text-gray-400 mt-1 max-w-xs">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
